import { useMemo } from 'react';

import axios, { Axios } from 'axios';

import { oimApiConfig } from '../../../config';
import { useAuthorization } from '../../../utils/Api';
import { TargetModel } from '../types';

export type CreateTargetParams = Partial<TargetModel>;
export type UpdateTargetParams = Partial<TargetModel>;
export type DeleteTargetParams = Pick<TargetModel, 'appId' | 'targetId'>;

class TargetsService {
  constructor(private readonly http: Axios) {}

  async createTarget({ appId, ...params }: CreateTargetParams): Promise<TargetModel> {
    const { data } = await this.http.post<TargetModel>(this.buildUrl(appId), params);

    return data;
  }

  async updateTarget({ appId, targetId, ...params }: UpdateTargetParams): Promise<TargetModel> {
    const { data } = await this.http.patch<TargetModel>(this.buildUrl(appId, targetId), params);

    return data;
  }

  async deleteTarget({ appId, targetId }: DeleteTargetParams): Promise<TargetModel> {
    const { data } = await this.http.delete<TargetModel>(this.buildUrl(appId, targetId));

    return data;
  }

  private buildUrl(appId?: string, targetId?: string): string {
    let url = `apps/${appId}/targets`;

    if (targetId) {
      url += `/${targetId}`;
    }

    return url;
  }
}

export const useTargetsService = () => {
  const http = axios.create({
    baseURL: oimApiConfig.apiBaseUrl,
  });

  useAuthorization(http);

  return useMemo(() => new TargetsService(http), [http]);
};
